import CheckInAlreadyActivatedModal from './CheckInAlreadyActivatedModal';

export default CheckInAlreadyActivatedModal;
